import { styled } from "styled-components";

export const IconsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.default[600]};
  font-weight: 600;
  max-width: 175px;
  text-wrap: wrap;
`;

export const SectionTitle = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.default.default};
`;
export const IconContainer = styled.div<{
  $compact?: boolean;
  $column?: boolean;
}>`
  display: flex;
  flex-direction: ${(props) => (props.$column ? "column" : "row")};
  gap: ${(props) => (props.$compact ? "12px" : "24px")};
`;
